import { render, staticRenderFns } from "./Home2.vue?vue&type=template&id=00841d45&scoped=true&"
import script from "./Home2.vue?vue&type=script&lang=js&"
export * from "./Home2.vue?vue&type=script&lang=js&"
import style0 from "./Home2.vue?vue&type=style&index=0&lang=stylus&"
import style1 from "./Home2.vue?vue&type=style&index=1&id=00841d45&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00841d45",
  null
  
)

export default component.exports